import React from 'react';
import PropTypes from 'prop-types';

class ScrollPager extends React.Component {
  componentDidMount() {
    window.addEventListener('scroll', this.handleScrollListener, false);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScrollListener, false);
  }

  handleScrollListener = () => {
    if (this.props.isLoading) return;
    const body = document.body;
    if (body.scrollHeight <= window.scrollY + window.innerHeight) {
      this.props.onScrollBottom();
    }
  };

  render() {
    return React.Children.only(this.props.children);
  }
}

ScrollPager.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  onScrollBottom: PropTypes.func.isRequired,
};

ScrollPager.defaultProps = {
  isLoading: false,
};

export default ScrollPager;
